import React, { Component, Fragment } from 'react';
import { Form, Input, Modal, InputNumber, Select, Switch, TimePicker } from 'antd';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
const Option = Select.Option;

@inject('store')
@observer
export class TriggerFormComponent extends Component {
    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Modal
                title={this.props.edit ? `Edit Rule: ${this.props.data.name}` : 'Create Rule'}
                visible={this.props.visible}
                onOk={() => {
                    this.props.form.validateFields((err, obj) => {
                        if (!err) {
                            if (this.props.edit) {
                                this.props.store.botStore.triggerStore.updateTrigger(
                                    this.props.id,
                                    obj
                                );
                                this.props.onCancel();
                                return;
                            }
                            this.props.store.botStore.triggerStore.addTrigger(obj);
                            this.props.onCancel();
                        }
                    });
                }}
                onCancel={() => {
                    this.props.onCancel();
                }}
            >
                <Form>
                    <Form.Item label={'Type'}>
                        {getFieldDecorator('type', {
                            initialValue: 'strategy',
                            rules: [{ required: true, message: 'Field is required' }]
                        })(
                            <Select>
                                <Option value="strategy">Strategy</Option>
                                <Option value="time_interval">Time Interval</Option>
                                <Option value="time_range">Time Range</Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item label={'Name'}>
                        {getFieldDecorator('name', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(<Input />)}
                    </Form.Item>

                    <Form.Item label={'Active'} extra={''}>
                        {getFieldDecorator('active', {
                            initialValue: true,
                            valuePropName: 'checked'
                        })(<Switch />)}
                    </Form.Item>

                    {this.renderStrategyFields()}
                    {this.renderTimeFields()}
                    {this.renderTimeRangeFields()}
                </Form>
            </Modal>
        );
    }

    renderStrategyFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const symbols = Object.keys(this.props.store.botStore.marketStore.market).map(
            p => this.props.store.botStore.marketStore.market[p]
        );

        if (getFieldValue('type') === 'strategy') {
            return (
                <Fragment>
                    <Form.Item label={'Cooldown'}>
                        {getFieldDecorator('cooldown', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(<InputNumber min={0} />)}
                    </Form.Item>

                    <Form.Item label={'Symbol'}>
                        {getFieldDecorator('symbol', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(
                            <Select showSearch style={{ width: '100%' }}>
                                {symbols.map(symbol => (
                                    <Option key={symbol.name} value={symbol.name}>
                                        {symbol.name}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item label={'Automation Strategy'}>
                        {getFieldDecorator('strategy_id', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(
                            <Select showSearch style={{ width: '100%' }}>
                                {this.props.store.strategyStore.trigger
                                    .slice()
                                    .sort((a, b) => {
                                        if (a.name < b.name) return -1;
                                        if (a.name > b.name) return 1;
                                        return 0;
                                    })
                                    .map(s => {
                                        return (
                                            <Option value={s.id} key={s.id}>
                                                {s.name}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item
                        label={'Override Cooldown'}
                        extra={'If a cooldown is in effect it will be ignored'}
                    >
                        {getFieldDecorator('override_cooldown', {
                            initialValue: false,
                            valuePropName: 'checked'
                        })(<Switch />)}
                    </Form.Item>
                </Fragment>
            );
        }

        return null;
    }

    renderTimeRangeFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        if (getFieldValue('type') === 'time_range') {
            return (
                <Fragment>
                    <Form.Item label={'Between'}>
                        {getFieldDecorator('start_time', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(<TimePicker format={'HH:mm'} minuteStep={5} />)}
                    </Form.Item>

                    <Form.Item label={'And'}>
                        {getFieldDecorator('end_time', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(<TimePicker format={'HH:mm'} minuteStep={5} />)}
                    </Form.Item>
                </Fragment>
            );
        }

        return null;
    }

    renderTimeFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        if (getFieldValue('type') === 'time_interval') {
            return (
                <Fragment>
                    <Form.Item label={'Run rule every'}>
                        {getFieldDecorator('interval', {
                            rules: [{ required: true, message: 'Field is required' }]
                        })(<Input type={'number'} addonAfter={'mins'} precision={0} />)}
                    </Form.Item>
                </Fragment>
            );
        }

        return null;
    }
}

export const TriggerForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            if (k === 'start_time') {
                data[k] = Form.createFormField({ value: moment(props.data[k], 'HH:mm') });
            } else if (k === 'end_time') {
                data[k] = Form.createFormField({ value: moment(props.data[k], 'HH:mm') });
            } else {
                data[k] = Form.createFormField({ value: props.data[k] });
            }
        });
        return data;
    }
})(TriggerFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Bot/TriggerView/TriggerForm.js